<ng-container *ngIf="false">
  <div id="layout-wrapper" *ngIf="!hideChrome">


    <ng-template #quickActionsModal>
      <div class="quick-actions-modal">
        <div class="quick-actions-modal__header">
          <div class="quick-actions-modal__title">
            <img src="assets/sidebar-icons/cursor-box.svg" alt="" aria-hidden="true" />
            <span>Quick Action</span>
          </div>
          <button type="button" class="quick-actions-modal__close" (click)="closeQuickActionsModal()">
            <i class="ri-close-line"></i>
          </button>
        </div>

        <div class="quick-actions-modal__body">
          <div class="quick-actions-modal__search">
            <i class="ri-search-line"></i>
            <input type="text" [(ngModel)]="quickActionsSearchTerm" placeholder="Search quick actions" />
          </div>

          <div class="quick-actions-modal__list">
            <ng-container *ngIf="filteredQuickActions.length; else quickActionsNoResult">
              <ng-container *ngFor="let action of filteredQuickActions; let i = index">
                <button type="button" class="quick-actions-modal__item" (click)="onQuickActionSelect(action)">
                  <span class="quick-actions-modal__item-start">
                    <span class="quick-actions-modal__item-icon" aria-hidden="true">
                      <img [src]="action.iconPath" alt="" />
                    </span>
                    <span class="quick-actions-modal__item-label">{{ action.label }}</span>
                  </span>
                  <span class="quick-actions-modal__item-shortcut">
                    <span class="quick-actions-modal__shortcut-key"
                      *ngFor="let key of getShortcutKeys(action.shortcut)">
                      <img [src]="getShortcutIcon(key)" [alt]="key" />
                    </span>
                  </span>
                </button>
                <div *ngIf="shouldShowQuickActionDivider(action, i, filteredQuickActions)"
                  class="quick-actions-modal__divider"></div>
              </ng-container>
            </ng-container>
            <ng-template #quickActionsNoResult>
              <div class="quick-actions-modal__empty">No quick action found for your search.</div>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-template>

    <header id="page-topbar">

      <div class="layout-width">

        <div class="navbar-header">

          <div class="d-flex">

            <div class="navbar-brand-box horizontal-logo">

              <a href="index.html" class="logo logo-dark">

                <span class="logo-sm">

                  <img src="assets/logo/logo-dark.png" alt="" height="22">

                </span>

                <span class="logo-lg">

                  <img src="assets/logo/logo-dark.png" alt="" height="40">

                </span>

              </a>

              <a href="index.html" class="logo logo-light">

                <span class="logo-sm">

                  <img src="assets/logo/logo-light.png" alt="" height="22">

                </span>

                <span class="logo-lg">

                  <img src="assets/logo/logo-light.png" alt="" height="40">

                </span>

              </a>

            </div>

            <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
              id="topnav-hamburger-icon">

              <span class="hamburger-icon">
                <span></span>
                <span></span>
                <span></span>
              </span>

            </button>

          </div>

          <div class="d-flex align-items-center gap-3">

            <div class="dropdown d-md-none topbar-head-dropdown header-item">

              <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                <i class="bx bx-search fs-22"></i>

              </button>

              <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown">

                <form class="p-3">

                  <div class="form-group m-0">

                    <div class="input-group">

                      <input type="text" class="form-control" placeholder="Search ..."
                        aria-label="Recipient's username">

                      <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>

                    </div>

                  </div>

                </form>

              </div>

            </div>

            <div class="ms-1 header-item  d-none">
              <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                data-toggle="fullscreen">
                <i class='bx bx-fullscreen fs-22'></i>
              </button>
            </div>

            <div class="ms-1 header-item  d-none">
              <button type="button"
                class="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle light-dark-mode">
                <i class="bx bx-moon fs-22"></i>
                <i class="bx bx-sun fs-22"></i>
              </button>
            </div>

            <div class="header-item" *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId)">
              <ng-select [items]="companies$ | async" bindLabel="name" bindValue="id" [(ngModel)]="selectedCompany"
                dropdownPosition="bottom" (change)="onCompanyChange($event)" [clearable]="false" [searchable]="false"
                placeholder="Select Organization">
              </ng-select>
            </div>

            <div class="header-item">
              <div class="dropdown">
                <button class="btn-selectedRole dropdown-toggle d-flex align-items-center px-3 py-2 rounded-3 gap-2"
                  type="button" id="roleDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                  <img src="assets/images/svg/user-role.svg" class="mb-1"> Switch Role
                  <img src="assets/images/svg/down-arrow.svg">
                </button>

                <ul class="dropdown-menu" aria-labelledby="roleDropdown">
                  <li *ngFor="let role of uniqueRoles | userRolesToList">
                    <button class="dropdown-item d-flex justify-content-between align-items-center"
                      [class.disabled]="role.roleId === activeRoleId" (click)="onSwitchRole(role)">
                      <span>{{ role?.roleName }}</span>
                      <span *ngIf="role.roleId === activeRoleId" class="badge bg-success ms-2">Active</span>
                    </button>
                  </li>
                </ul>
              </div>

            </div>

            <!-- System Admin portal has no notifications page (QA B80): no bell outside an organization. -->
          <div *ngIf="!(isSystemAdmin && !isImpersonating)" #notificationDropdown class="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown">
              <!-- <button type="button" (click)="reFreshNotifications()"
              class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" style="border: 1px solid #DCDCDC;"
              id="page-header-notifications-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside"
              aria-haspopup="true" aria-expanded="false">
              <i class='bx bx-bell fs-22'></i>
              <ng-container *ngIf="counts$ | async as count">
                <span class="position-absolute translate-middle bg-danger rounded-circle"
                  style="width: 10px; height: 10px; top: 0; right: 0; display: inline-block;">
                  <span class="visually-hidden">unread messages</span>
                </span>
              </ng-container>

            </button> -->

              <button #dropdownToggle type="button" (click)="onNotificationIconClick()"
                class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" style="border: 1px solid #DCDCDC;"
                id="page-header-notifications-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside"
                aria-haspopup="true" aria-expanded="false">
                <i class='bx bx-bell fs-22'></i>
                <ng-container *ngIf="counts$ | async as unreadCount"><span *ngIf="unreadCount > 0" class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">{{ formatNotificationCount(unreadCount) }}<span class="visually-hidden">unread messages</span></span></ng-container>
              </button>
              <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 notifications-dropdown-menu"
                aria-labelledby="page-header-notifications-dropdown">

                <div class="dropdown-head rounded-top">
                  <div class="p-3 border-bottom notifications-dropdown-head">
                    <div class="d-flex flex-nowrap align-items-end justify-content-between gap-2">
                      <ul class="nav nav-tabs dropdown-notification-tabs mb-0 border-0 flex-grow-1 min-w-0"
                        role="tablist">
                        <li class="nav-item flex-shrink-0" role="presentation">
                          <button type="button" class="nav-link bell-tab-button bg-transparent p-0 me-3 text-nowrap"
                            [class.active]="activeNotificationTab === 'notifications'"
                            (click)="activeNotificationTab = 'notifications'">
                            <span class="align-middle">Notifications</span>
                            <span *ngIf="notificationsTabUnreadDot$ | async"
                              class="ms-1 align-middle bell-tab-unread-dot" aria-hidden="true"></span>
                          </button>
                        </li>
                        <li class="nav-item flex-shrink-0" role="presentation">
                          <button type="button" class="nav-link bell-tab-button bg-transparent p-0 text-nowrap"
                            [class.active]="activeNotificationTab === 'announcements'"
                            (click)="activeNotificationTab = 'announcements'">
                            <span class="align-middle">Announcements</span>
                            <span *ngIf="announcementsTabUnreadDot$ | async"
                              class="ms-1 align-middle bell-tab-unread-dot" aria-hidden="true"></span>
                          </button>
                        </li>
                      </ul>
                      <button type="button"
                        class="notifications-dropdown-mark-all d-inline-flex align-items-center flex-shrink-0 text-nowrap border-0"
                        (click)="activeNotificationTab === 'announcements' ? markAllAnnouncementsAsRead() : markAllAsRead()">
                        <img src="assets/images/svg/mark-tick.svg" alt="" aria-hidden="true">
                        <span class="notifications-mark-all-read-link">Mark all as read</span>
                      </button>
                    </div>
                  </div>
                </div>



                <div class="tab-content position-relative" id="notificationItemsTabContent">
                  <div class="tab-pane fade" [class.show]="activeNotificationTab === 'notifications'"
                    [class.active]="activeNotificationTab === 'notifications'" id="all-noti-tab" role="tabpanel">
                    <div data-simplebar style="max-height: 300px; overflow-y: auto;" class="pe-2">
                      <ng-container
                        *ngIf="activeNotificationTab === 'notifications' && (notificationlist$ | async) as data">
                        <ng-container *ngIf="data && data.items.length; else noData">
                          <div class="text-reset notification-item d-block dropdown-item position-relative"
                            [ngClass]="{ 'read-noti-bg-light': notification.state === 'UnRead' }"
                            *ngFor="let notification of data.items; trackBy: trackByFn">
                            <div class="d-flex">

                              <div class="flex-grow-1">
                                <a (click)="onNotificationClick(notification)"
                                  [attr.data-module]="notification.module | kebabCase"
                                  class="stretched-link text-decoration-none cursor-pointer">

                                  <div class="d-flex align-items-center justify-content-between mb-1">
                                    <div class="d-flex align-items-center gap-2">
                                      <img *ngIf="notification.state === 'UnRead'"
                                        src="assets/images/svg/notification-dot.svg" alt="icon" />
                                      <h3 class="mb-0 text-truncate"
                                        style="font-size: 15px; color: #0F172A; max-width: 150px;">
                                        {{ notification.title }}
                                      </h3>
                                    </div>
                                    <p class="mb-0 fs-11 fw-medium text-muted">
                                      <span>
                                        {{ notification.createdAt | relativeTime }}
                                      </span>
                                    </p>
                                  </div>
                                  <h6 class="mt-0 mb-2 lh-base text-muted fs-12">
                                    {{ notification.body }}
                                  </h6>
                                </a>
                              </div>

                            </div>
                          </div>

                        </ng-container>

                        <ng-template #noData>
                          <ng-container *ngIf="!(isLoading$ | async)">
                            <div class="card-body p-4 m-4">
                              <div class="noresult">
                                <div class="text-center">
                                  <h5 class="mt-2">Sorry! No Result Found</h5>
                                  <p class="text-muted mb-0">
                                    We did not find any notification for your search.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </ng-template>
                      </ng-container>
                    </div>
                    <div (click)="onViewAllNotifications()" class="text-center border-top p-2 all-notification"
                      style="background-color: #fff; position: sticky; bottom: 0; z-index: 10; cursor: pointer;">
                      View all notifications
                    </div>
                  </div>
                  <div class="tab-pane fade" [class.show]="activeNotificationTab === 'announcements'"
                    [class.active]="activeNotificationTab === 'announcements'" id="announcements-tab" role="tabpanel">
                    <div class="px-3 pt-2 pb-1 text-muted small fw-medium">Today</div>
                    <div data-simplebar style="max-height: 300px; overflow-y: auto; overflow-x: hidden;" class="pe-2">
                      <ng-container
                        *ngIf="activeNotificationTab === 'announcements' && (announcementlist$ | async) as data">
                        <ng-container *ngIf="data && data.items.length; else noDataAnnouncements">
                          <div class="text-reset notification-item d-block dropdown-item position-relative m-1"
                            style="border-radius: 5px;"
                            [ngClass]="{ 'read-noti-bg-light': announcement.status === 'UnRead' }"
                            *ngFor="let announcement of data.items; trackBy: trackByAnnouncementFn">
                            <div class="d-flex">

                              <div class="flex-grow-1">
                                <a (click)="onAnnouncementClick(announcement)"
                                  class="stretched-link text-decoration-none cursor-pointer">
                                  <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap gap-1">
                                    <span [ngClass]="getAnnouncementTypeClass(announcement.type)"
                                      class="announcement-type-pill-dropdown">
                                      <span class="announcement-type-dot"></span>
                                      {{ getAnnouncementTypeLabel(announcement.type) }}
                                    </span>
                                    <p class="mb-0 fs-11 fw-medium text-muted flex-shrink-0">
                                      <span>{{ (announcement.createdAt || announcement.scheduledDate) | relativeTime
                                        }}</span>
                                    </p>
                                  </div>
                                  <div class="d-flex align-items-center gap-2 mb-1">
                                    <img *ngIf="announcement.status === 'UnRead'"
                                      src="assets/images/svg/notification-dot.svg" alt="icon" />
                                    <h3 class="mb-0 text-truncate"
                                      style="font-size: 15px; color: #0F172A; font-weight: 600;">
                                      {{ announcement.title || '—' }}
                                    </h3>
                                  </div>
                                  <h6 class="mt-0 mb-2 lh-base text-muted fs-12">
                                    <span class="announcement-description-truncate">
                                      {{ getAnnouncementDescriptionPreview(announcement.description) }}
                                    </span>
                                  </h6>
                                </a>
                              </div>

                            </div>
                          </div>

                        </ng-container>

                        <ng-template #noDataAnnouncements>
                          <ng-container *ngIf="!(announcementsLoading$ | async)">
                            <div class="card-body p-4 m-4">
                              <div class="noresult">
                                <div class="text-center">
                                  <h5 class="mt-2">Sorry! No Result Found</h5>
                                  <p class="text-muted mb-0">
                                    We did not find any announcement for your search.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </ng-template>
                      </ng-container>
                    </div>
                    <div (click)="onViewAllAnnouncements()" class="text-center border-top p-2 all-notification"
                      style="background-color: #fff; position: sticky; bottom: 0; z-index: 10; color: #6964E1; font-weight: 500; cursor: pointer;">
                      View all Announcements
                    </div>
                  </div>
                </div>
              </div>

            </div>

          <!-- Ask MD AI button. Hidden on the AI page itself — see the md-shell header below;
               this is the older header variant and both must agree. Also hidden when the user has
               turned AI off in their AI Preferences. -->
          <div class="header-item" *ngIf="!isAiFirstRoute && aiPrefSvc.allowed">
            <button type="button"
                    class="btn btn-sm d-flex align-items-center gap-1 rounded-pill border"
                    style="border-color: #d0d5dd !important; padding: 6px 14px;"
                    (click)="toggleMdAiPanel()">
              <i class="bi bi-stars" style="color: #6366f1;"></i>
              <span class="d-none d-md-inline fw-medium" style="font-size: 13px;">Ask MD AI</span>
            </button>
          </div>

            <div class="dropdown header-item topbar-user" dropdown>

              <button #profileDropdownToggle type="button" class="btn" dropdownToggle>

                <span class="d-flex align-items-center">

                  <ng-container *ngIf="!user?.profilePictureWebUrl">

                    <div class="avatar-xs flex-shrink-0">

                      <div class="avatar-title bg-info-subtle text-info rounded-circle">

                        {{user | userPrefix}}

                      </div>

                    </div>

                  </ng-container>

                  <ng-container *ngIf="user?.profilePictureWebUrl">

                    <img class="rounded-circle header-profile-user" [src]="user?.profilePictureWebUrl" />

                  </ng-container>

                  <span class="text-start ms-xl-2">

                    <!-- <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">

                    {{user.firstName}} {{user.lastName}}

                  </span> -->

                    <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                      {{ getFirstThreeWords(getUserName(user)) }}
                    </span>


                    <span class="d-none d-xl-block ms-1 fs-12 user-name-sub-text">

                      {{getRoleName(activeRoleId)}}

                    </span>

                  </span>

                </span>

              </button>

              <div class="dropdown-menu dropdown-menu-end" style="top: 72px !important;" *dropdownMenu>

                <h6 class="dropdown-header">Welcome {{user.firstName}}!</h6>

                <a class="dropdown-item" [routerLink]="['/profile']"><i
                    class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span
                    class="align-middle">Profile</span></a>

                <a class="dropdown-item" (click)="openChangePasswordModal()"><i
                    class="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span class="align-middle">Change
                    Password</span></a>

                <a class="dropdown-item"
                  *ngIf="checkIfUserHasRole(RoleConstant.companyAdminId) || checkIfUserHasRole(RoleConstant.accountsPayableManager1) || checkIfUserHasRole(RoleConstant.accountsPayableManager2) || checkIfUserHasRole(RoleConstant.auditor2) || checkIfUserHasRole(RoleConstant.vpOperations) || checkIfUserHasRole(RoleConstant.srDirectorOperations) || checkIfUserHasRole(RoleConstant.directorOperations) || checkIfUserHasRole(RoleConstant.supervisor) || checkIfUserHasRole(RoleConstant.generalManager) || checkIfUserHasRole(RoleConstant.auditor1)"
                  [routerLink]="['/announcements/list']"><i
                    class="mdi mdi-bullhorn text-muted fs-16 align-middle me-1"></i> <span
                    class="align-middle">Announcement</span></a>

                <div class="dropdown-divider"></div>

                <a class="dropdown-item" (click)="logout()"><i
                    class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                    class="align-middle">Logout</span></a>

              </div>

            </div>

          </div>

        </div>

      </div>

    </header>

    <div class="app-menu navbar-menu" (click)="closeProfileDropdown()">

      <div id="scrollbar">

        <div class="container-fluid">

          <div id="two-column-menu">

          </div>

          <ul class="navbar-nav" id="navbar-nav">

            <li class="nav-item me-4" (mouseenter)="openMenuOnMouseEnter($event)"
              (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">

                <i class="bx bxs-bar-chart-alt-2"></i>

                <span data-key="t-dashboards">

                  Dashboards

                </span>

              </a>

              <div class="collapse menu-dropdown" id="sidebarDashboards">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item">

                    <a routerLink="/" class="nav-link" (click)="closeMenuOnClick($event)" data-key="t-analytics">
                      Home</a>

                  </li>

                </ul>

              </div>

            </li>

            <li class="nav-item me-4"
              *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || 
            checkIfUserHasRole(RoleConstant.companyAdminId) || checkIfUserHasRole(RoleConstant.vpOperations) || checkIfUserHasRole(RoleConstant.srDirectorOperations) || 
            checkIfUserHasRole(RoleConstant.directorOperations) || checkIfUserHasRole(RoleConstant.supervisor) || checkIfUserHasRole(RoleConstant.generalManager)"
              (mouseenter)="openMenuOnMouseEnter($event)" (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">

                <i class=" bx bx-buildings"></i>

                <span data-key="t-dashboards">

                  Organizations

                </span>

              </a>

              <div class="collapse menu-dropdown">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item">

                    <a routerLink="/companies/list" class="nav-link" (click)="closeMenuOnClick($event)"
                      data-key="t-analytics"> Organizations List</a>

                  </li>

                  <li>
                    <hr class="dropdown-divider">
                  </li>

                  <ng-container *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId)">

                    <li class="nav-item">

                      <a routerLink="/company/create" class="nav-link" (click)="closeMenuOnClick($event)"
                        data-key="t-crm"> Create Organization </a>

                    </li>

                  </ng-container>

                </ul>

              </div>

            </li>

            <li class="nav-item me-4" *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId) || 
                   checkIfUserHasRole(RoleConstant.srDirectorOperations) || checkIfUserHasRole(RoleConstant.directorOperations) || 
                   checkIfUserHasRole(RoleConstant.supervisor) || checkIfUserHasRole(RoleConstant.generalManager) 
                   || checkIfUserHasRole(RoleConstant.vpOperations)" (mouseenter)="openMenuOnMouseEnter($event)"
              (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">

                <i class="bx bx-restaurant"></i>

                <span data-key="t-dashboards">

                  Locations

                </span>

              </a>

              <div class="collapse menu-dropdown" id="sidebarDashboards">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item">

                    <a routerLink="/stores/list" class="nav-link" (click)="closeMenuOnClick($event)"> Locations List</a>

                  </li>

                  <ng-container
                    *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId)">

                    <li class="nav-item">

                      <a routerLink="/store/create" class="nav-link" (click)="closeMenuOnClick($event)"> Create Location
                      </a>

                    </li>

                  </ng-container>

                </ul>

              </div>

            </li>

            <li class="nav-item me-4" *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId) || 
                   checkIfUserHasRole(RoleConstant.srDirectorOperations) || checkIfUserHasRole(RoleConstant.directorOperations) || 
                   checkIfUserHasRole(RoleConstant.supervisor) || checkIfUserHasRole(RoleConstant.generalManager) 
                   || checkIfUserHasRole(RoleConstant.vpOperations)" (mouseenter)="openMenuOnMouseEnter($event)"
              (mouseleave)="closeMenuOnMouseLeave($event)">
              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">
                <i class="bx bx-group"></i>
                <span data-key="t-dashboards">
                  Companies
                </span>
              </a>
              <div class="collapse menu-dropdown">
                <ul class="nav nav-sm flex-column">
                  <li class="nav-item">
                    <a routerLink="/store-groups/list" class="nav-link" (click)="closeMenuOnClick($event)"> Companies
                      List </a>
                  </li>
                  <ng-container
                    *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId)">
                    <li class="nav-item">
                      <a routerLink="/store-group/create" class="nav-link" (click)="closeMenuOnClick($event)"> Create
                        Company </a>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </li>

            <li class="nav-item me-4" *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId) || 
                   checkIfUserHasRole(RoleConstant.srDirectorOperations) || checkIfUserHasRole(RoleConstant.directorOperations) || 
                   checkIfUserHasRole(RoleConstant.supervisor) || checkIfUserHasRole(RoleConstant.generalManager) 
                   || checkIfUserHasRole(RoleConstant.vpOperations)" (mouseenter)="openMenuOnMouseEnter($event)"
              (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">

                <i class="bx bx-user"></i>

                <span data-key="t-dashboards">

                  Users

                </span>

              </a>

              <div class="collapse menu-dropdown">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item">

                    <a routerLink="/users/list" class="nav-link" (click)="closeMenuOnClick($event)"> Users List </a>

                  </li>

                  <li class="nav-item"
                    *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId)">

                    <a routerLink="/users/new" class="nav-link" (click)="closeMenuOnClick($event)"> Create User </a>

                  </li>

                </ul>

              </div>

            </li>

            <li class="nav-item me-4"
              *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId) || 
            checkIfUserHasRole(RoleConstant.srDirectorOperations) || checkIfUserHasRole(RoleConstant.directorOperations) || 
            checkIfUserHasRole(RoleConstant.supervisor) || checkIfUserHasRole(RoleConstant.generalManager) || checkIfUserHasRole(RoleConstant.vpOperations) ||  checkIfUserHasRole(RoleConstant.accountsPayableManager1) || checkIfUserHasRole(RoleConstant.accountsPayableManager2)"
              (mouseenter)="openMenuOnMouseEnter($event)" (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">

                <i class="bx bx-user"></i>

                <span data-key="t-dashboards">

                  Vendors

                </span>

              </a>

              <div class="collapse menu-dropdown">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item">

                    <a routerLink="/vendors/list" class="nav-link" (click)="closeMenuOnClick($event)"> Vendors List </a>

                  </li>

                  <li class="nav-item"
                    *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId) || 
            checkIfUserHasRole(RoleConstant.srDirectorOperations) || checkIfUserHasRole(RoleConstant.directorOperations) ||  checkIfUserHasRole(RoleConstant.accountsPayableManager1) || checkIfUserHasRole(RoleConstant.accountsPayableManager2) || checkIfUserHasRole(RoleConstant.vpOperations)">

                    <a routerLink="/vendors/create" class="nav-link" (click)="closeMenuOnClick($event)"> Create Vendor
                    </a>

                  </li>

                </ul>

              </div>

            </li>

            <li class="nav-item me-4"
              *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId) || 
          checkIfUserHasRole(RoleConstant.srDirectorOperations) || checkIfUserHasRole(RoleConstant.directorOperations) || 
          checkIfUserHasRole(RoleConstant.supervisor) || checkIfUserHasRole(RoleConstant.generalManager) 
          || checkIfUserHasRole(RoleConstant.vpOperations) || checkIfUserHasRole(RoleConstant.employeeId) || checkIfUserHasRole(RoleConstant.vendorId)"
              (mouseenter)="openMenuOnMouseEnter($event)" (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">

                <i class="bx bx-wrench"></i>

                <span data-key="t-dashboards">

                  Repair & Maintenance

                </span>

              </a>

              <div style="min-width: 14rem;" class="collapse menu-dropdown" id="sidebarDashboards">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item">

                    <a routerLink="/repairs-and-maintenance/list" class="nav-link" (click)="closeMenuOnClick($event)">
                      Repair & Maintenance List </a>

                  </li>
                  <li class="nav-item"
                    *ngIf="!checkIfUserHasRole(RoleConstant.globalAdminId) && !checkIfUserHasRole(RoleConstant.companyAdminId) && !checkIfUserHasRole(RoleConstant.vendorId)">

                    <a routerLink="/repairs-and-maintenance/new" class="nav-link" (click)="closeMenuOnClick($event)">
                      Create Repair Request </a>

                  </li>

                  <li class="nav-item" *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId) || checkIfUserHasRole(RoleConstant.companyAdminId) || 
                checkIfUserHasRole(RoleConstant.srDirectorOperations) || checkIfUserHasRole(RoleConstant.directorOperations) || 
                checkIfUserHasRole(RoleConstant.supervisor) || checkIfUserHasRole(RoleConstant.generalManager) 
                || checkIfUserHasRole(RoleConstant.vpOperations)" (mouseenter)="openNestedMenuOnMouseEnter($event)"
                    (mouseleave)="closeNestedMenuOnMouseLeave($event)">

                    <a class="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#sidebarEmail"
                      aria-expanded="false" aria-controls="sidebarEmail">

                      Approval Process

                    </a>

                    <div style="min-width: 13.5rem;" class="collapse menu-dropdown" id="sidebarEmail"
                      (mouseenter)="openNestedMenuOnMouseEnter($event)"
                      (mouseleave)="closeNestedMenuOnMouseLeave($event)">

                      <ul class="nav nav-sm flex-column">

                        <li class="nav-item">

                          <a routerLink="/approval-processes/list"
                            [queryParams]="{ type: serviceRequestType.repairAndMainenance }" class="nav-link"
                            (click)="closeMenuOnClick($event)" data-key="t-mailbox"> Approval Process List </a>

                        </li>

                        <li class="nav-item">

                          <a routerLink="/approval-process/create"
                            [queryParams]="{ type: serviceRequestType.repairAndMainenance }" class="nav-link"
                            (click)="closeMenuOnClick($event)" data-key="t-mailbox"> Create Approval Process </a>

                        </li>

                      </ul>

                    </div>

                  </li>

                </ul>

              </div>

            </li>

            <li class="nav-item me-4" *ngIf="expenseNavGroup as expenseGroup"
              (mouseenter)="openMenuOnMouseEnter($event)" (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">

                <i class="bx bx-wrench"></i>

                <span data-key="t-dashboards">

                  {{ expenseGroup.menu }}

                </span>

              </a>

              <div class="collapse menu-dropdown" id="sidebarDashboards">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item" *ngFor="let subMenu of expenseGroup.subMenus">

                    <a [routerLink]="getExpenseSubMenuRoute(subMenu.pageUrl)" class="nav-link"
                      [class.active]="isExpenseSubMenuActive(subMenu.pageUrl)"
                      (click)="closeMenuOnClick($event)"> {{ subMenu.page }} </a>

                  </li>

                  <!-- <li class="nav-item">

                  <a class="nav-link collapsed" data-bs-toggle="collapse">

                    Approval Process

                  </a>

                  <div class="collapse menu-dropdown" id="sidebarEmail">

                    <ul class="nav nav-sm flex-column">

                      <li class="nav-item">

                        <a routerLink="/approval-processes/list" [queryParams]="{ type: serviceRequestType.expense }"
                          class="nav-link" data-key="t-mailbox"> Approval Process List </a>

                      </li>

                      <li class="nav-item">

                        <a routerLink="/approval-process/create" [queryParams]="{ type: serviceRequestType.expense }"
                          class="nav-link" data-key="t-mailbox"> Create Approval Process </a>

                      </li>

                    </ul>

                  </div>

                </li> -->

                </ul>

              </div>

            </li>

            <li class="nav-item" *ngFor="let apGroup of apNavGroups"
              (mouseenter)="openMenuOnMouseEnter($event)" (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link ps-0 cursor-pointer" data-bs-toggle="collapse">

                <i class="bx bx-money"></i>

                <span data-key="t-dashboards">

                  {{ apGroup.menu }}

                </span>

              </a>

              <div style="min-width: 13.5rem;" class="collapse menu-dropdown" id="sidebarDashboards">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item" *ngFor="let subMenu of apGroup.subMenus">

                    <a [routerLink]="getApSubMenuRoute(subMenu.pageUrl)"
                      [queryParams]="getApSubMenuQueryParams(subMenu.pageUrl)"
                      [class.cursor-pointer]="!getApSubMenuRoute(subMenu.pageUrl)" class="nav-link"
                      [class.active]="isApSubMenuActive(subMenu.pageUrl)"
                      (click)="onApSubMenuItemClick($event, subMenu.pageUrl, apGroup)"> {{ subMenu.page }} </a>

                  </li>

                </ul>

              </div>

            </li>
            <li class="nav-item" *ngIf="canShowAssetManagementNav()"
              (mouseenter)="openMenuOnMouseEnter($event)" (mouseleave)="closeMenuOnMouseLeave($event)">

              <a class="nav-link menu-link cursor-pointer" data-bs-toggle="collapse">

                <i class="bx bx-money"></i>

                <span data-key="t-dashboards">

                  Asset Management

                </span>

              </a>

              <div style="min-width: 13.5rem;" class="collapse menu-dropdown" id="sidebarDashboards">

                <ul class="nav nav-sm flex-column">

                  <li class="nav-item">

                    <a routerLink="/asset-management/list" class="nav-link" (click)="closeMenuOnClick($event)"> Assets
                      List </a>

                  </li>

                  <li class="nav-item" *ngIf="!checkIfUserHasRole(RoleConstant.employeeId)">

                    <a routerLink="/asset-management/new" class="nav-link" (click)="closeMenuOnClick($event)"> Create
                      Asset </a>

                  </li>

                </ul>

              </div>

            </li>

          </ul>

        </div>

      </div>

      <div class="sidebar-background"></div>

    </div>

  </div>

  <div class="main-content" [ngClass]="{ 'invite-mode': hideChrome }">

    <div class="page-content">

      <div class="container-fluid">

        <router-outlet></router-outlet>

      </div>

    </div>

  </div>
</ng-container>

<ng-container *ngIf="hideChrome; else appShellLayout">
  <router-outlet></router-outlet>
</ng-container>

<ng-template #appShellLayout>
  <div class="md-shell" [class.md-shell--collapsed]="isSidebarCollapsed"
    [class.md-shell--mobile-nav-open]="isMobileSidebarOpen"
    [class.md-shell--hover-flyout]="useSidebarHoverFlyout"
    [class.md-shell--with-banner]="isImpersonating || (bannerAnnouncements.length > 0 && !!currentBannerAnnouncement)">
    <!-- AC 7.1: System Admin inside an organization. Takes the banner slot over announcements. -->
    <div *ngIf="isImpersonating" class="md-impersonation-banner" role="status">
      <span class="md-impersonation-banner__text">
        You are impersonating {{ impersonationSvc.organization?.name }} as System Admin. Hence only organization-level
        features are available.
      </span>
      <button type="button" class="md-impersonation-banner__exit" (click)="exitToPlatform()">
        Exit to Platform <i class="ri-arrow-right-up-line" aria-hidden="true"></i>
      </button>
    </div>
    <!-- Active Announcement banner at top: only today + status Active, slider if multiple -->
    <div *ngIf="!isImpersonating && bannerAnnouncements.length > 0 && currentBannerAnnouncement" class="active-announcement-banner"
      (click)="openBannerAnnouncementModal()" [ngClass]="getAnnouncementTypeClass(currentBannerAnnouncement?.type)">
      <div class="layout-width active-announcement-banner-row" [class.banner-row-centered]="!isBannerTextLong()"
        [class.active-announcement-banner-row--transitioning]="isBannerTransitioning">
        <span class="active-announcement-pill" [ngClass]="getAnnouncementTypeClass(currentBannerAnnouncement?.type)">•
          {{
          getBannerPillLabel() }}</span>
        <div class="active-announcement-content" [class.active-announcement-content-centered]="!isBannerTextLong()">
          <span class="active-announcement-text" [title]="bannerDisplayText">
            <ng-container *ngIf="currentBannerAnnouncement?.title && currentBannerAnnouncement?.description">
              <strong>{{ currentBannerAnnouncement.title }}</strong>: {{ currentBannerAnnouncement.description }}
            </ng-container>
            <ng-container *ngIf="currentBannerAnnouncement?.title && !currentBannerAnnouncement?.description">
              {{ currentBannerAnnouncement.title }}
            </ng-container>
            <ng-container *ngIf="!currentBannerAnnouncement?.title && currentBannerAnnouncement?.description">
              {{ currentBannerAnnouncement.description }}
            </ng-container>
          </span>
          <a *ngIf="isBannerTextLong()" (click)="$event.stopPropagation(); openBannerAnnouncementModal()"
            class="active-announcement-more">more</a>
          <a *ngIf="currentBannerAnnouncement?.callToAction" class="active-announcement-link"
            [href]="bannerTopCallToActionHref"
            (click)="$event.stopPropagation(); onBannerTopCallToActionClick($event)">{{
            (currentBannerAnnouncement?.callToActionLabel || '').trim() || 'Call to Action' }}</a>
        </div>
        <button type="button" class="active-announcement-dismiss"
          (click)="$event.stopPropagation(); dismissCurrentBannerAnnouncement()" aria-label="Dismiss announcement">
          <i class="bx bx-x fs-22"></i>
        </button>
      </div>
    </div>

    <!-- Full announcement modal (when "more" is clicked on banner) - shows the announcement that was opened, not the current banner slide -->
    <ng-template #bannerAnnouncementModal>
      <div class="banner-announcement-modal" *ngIf="bannerModalAnnouncement">
        <div class="banner-announcement-modal-header">
          <span class="banner-announcement-modal-badge"
            [ngClass]="getAnnouncementTypeClass(bannerModalAnnouncement?.type)">
            <span class="banner-announcement-modal-badge-dot"></span>
            {{ getBannerPillLabelForType(bannerModalAnnouncement?.type) }}
          </span>
          <button type="button" class="banner-announcement-modal-close" (click)="closeBannerAnnouncementModal()"
            aria-label="Close">
            <i class="bx bx-x fs-22"></i>
          </button>
        </div>
        <div class="banner-announcement-modal-body">
          <h2 class="banner-announcement-modal-title">{{ bannerModalAnnouncement?.title || '—' }}</h2>
          <p class="banner-announcement-modal-description">{{ bannerModalAnnouncement?.description || '—' }}</p>
        </div>
        <div class="banner-announcement-modal-footer">
          <button type="button" class="banner-announcement-modal-btn banner-announcement-modal-btn-close"
            (click)="closeBannerAnnouncementModal()">Close</button>
          <button *ngIf="bannerModalAnnouncement?.callToAction && bannerModalAnnouncement?.type === 'General'"
            type="button" class="banner-announcement-modal-btn banner-announcement-modal-btn-cta"
            (click)="onBannerModalCallToAction()">{{ (bannerModalAnnouncement?.callToActionLabel || '').trim() || 'Call
            to Action' }}</button>
        </div>
      </div>
    </ng-template>

    <aside #mdSidebar id="md-shell-sidebar-nav" class="md-shell__sidebar">
      <div class="md-shell__brand">
        <div class="md-shell__brand-logos" aria-hidden="true">
          <img class="md-shell__brand-logo md-shell__brand-logo--full" src="assets/images/MD-AI.svg"
            alt="Meal Dynamics AI" />
          <img class="md-shell__brand-logo md-shell__brand-logo--icon" src="assets/images/MD-AI.svg"
            alt="Meal Dynamics AI" />
        </div>
        <span class="visually-hidden">Meal Dynamics</span>
      </div>

      <nav class="md-shell__nav" (click)="onSidebarNavClick($event)">
        <div *ngIf="homepageNavGroup as homeGroup" class="md-shell__nav-group"
          [class.is-open]="isSidebarGroupFlyoutOpen('home')"
          [class.is-expanded]="!useSidebarHoverFlyout && !isSidebarCollapsed && expandedSidebarGroups.home"
          (mouseenter)="onSidebarNavGroupMouseEnter('home', $event)"
          (mouseleave)="onSidebarNavGroupMouseLeave('home', $event)">
          <a [routerLink]="null" [class.active]="isHomeGroupRouteActive()"
            [attr.title]="isSidebarCollapsed ? homeGroup.menu : null"
            (click)="onSidebarGroupParentClick($event, 'home')">
            <img src="assets/sidebar-icons/home.svg" alt="" aria-hidden="true" />
            <span>{{ homeGroup.menu }}</span>
          </a>
          <div class="md-shell__subnav"
            [class.is-expanded]="!useSidebarHoverFlyout && expandedSidebarGroups.home"
            [class.md-shell__subnav--flyout]="useSidebarHoverFlyout"
            [ngStyle]="isSidebarGroupFlyoutOpen('home') ? sidebarFlyoutNgStyle : null"
            *ngIf="shouldRenderSidebarSubnav('home')"
            (mouseenter)="onSidebarFlyoutMouseEnter('home')"
            (mouseleave)="onSidebarFlyoutMouseLeave('home', $event)">
            <div class="md-shell__subnav-inner">
              <div class="md-shell__subnav-title" *ngIf="isSidebarCollapsed">{{ homeGroup.menu }}</div>
              <a *ngFor="let subMenu of homeGroup.subMenus"
                [routerLink]="getHomeSubMenuRoute(subMenu.pageUrl)"
                [queryParams]="getHomeSubMenuQueryParams(subMenu.pageUrl)"
                [class.active]="isHomeSubMenuActive(subMenu.pageUrl)"
                (click)="onHomeSubMenuClick($event, subMenu.pageUrl)">{{ subMenu.page }}</a>
            </div>
          </div>
        </div>
        <!-- System Admin: the permission-based Homepage group is empty for this role, so link it directly. -->
        <a *ngIf="!homepageNavGroup && isSystemAdmin" routerLink="/"
          [class.active]="isHomeGroupRouteActive()"
          [attr.title]="isSidebarCollapsed ? 'Homepage' : null"
          (click)="onSidebarNavLinkClick($event, ['/'])">
          <img src="assets/sidebar-icons/home.svg" alt="" aria-hidden="true" />
          <span>Homepage</span>
        </a>
        <ng-container *ngIf="navAllowed('mdAi') && mdAiNavGroup as mdAiGroup">
          <a *ngIf="mdAiGroup.subMenus.length === 1"
            [routerLink]="getMdAiSubMenuRoute(mdAiGroup.subMenus[0].pageUrl)"
            [class.active]="isMdAiSubMenuActive(mdAiGroup.subMenus[0].pageUrl)"
            [attr.title]="isSidebarCollapsed ? mdAiGroup.subMenus[0].page : null"
            (click)="onMdAiSubMenuClick($event, mdAiGroup.subMenus[0].pageUrl)">
            <img src="assets/sidebar-icons/AI.svg" alt="" aria-hidden="true" />
            <span>{{ mdAiGroup.subMenus[0].page }}</span>
          </a>
        </ng-container>
        <div *ngFor="let apGroup of (navAllowed('ap') ? apNavGroups : [])" class="md-shell__nav-group"
          [class.is-open]="isApNavGroupFlyoutOpen(apGroup.menu)"
          [class.is-expanded]="!useSidebarHoverFlyout && isApNavGroupExpanded(apGroup.menu)"
          (mouseenter)="onApNavGroupMouseEnter(apGroup, $event)"
          (mouseleave)="onApNavGroupMouseLeave(apGroup, $event)">
          <a [routerLink]="null" [class.active]="isApNavGroupRouteActive(apGroup)"
            [attr.title]="isSidebarCollapsed ? apGroup.menu : null"
            (click)="onApNavGroupParentClick($event, apGroup)">
            <img src="assets/sidebar-icons/AP.svg" alt="" aria-hidden="true" />
            <span>{{ apGroup.menu }}</span>
          </a>
          <div class="md-shell__subnav"
            [class.is-expanded]="!useSidebarHoverFlyout && isApNavGroupExpanded(apGroup.menu)"
            [class.md-shell__subnav--flyout]="useSidebarHoverFlyout"
            [ngStyle]="isApNavGroupFlyoutOpen(apGroup.menu) ? sidebarFlyoutNgStyle : null"
            *ngIf="shouldRenderApSubnav(apGroup.menu)"
            (mouseenter)="onSidebarFlyoutMouseEnter(apGroupCollapseKey(apGroup.menu))"
            (mouseleave)="onSidebarFlyoutMouseLeave(apGroupCollapseKey(apGroup.menu), $event)">
            <div class="md-shell__subnav-inner">
              <div class="md-shell__subnav-title" *ngIf="isSidebarCollapsed">{{ apGroup.menu }}</div>
              <a *ngFor="let subMenu of apGroup.subMenus"
                [routerLink]="getApSubMenuRoute(subMenu.pageUrl)"
                [queryParams]="getApSubMenuQueryParams(subMenu.pageUrl)"
                [class.active]="isApSubMenuActive(subMenu.pageUrl)"
                (click)="onApSubMenuItemClick($event, subMenu.pageUrl, apGroup)">{{ subMenu.page }}</a>
            </div>
          </div>
        </div>
        <ng-container *ngIf="navAllowed('repair') && canShowRepairNav()">
          <ng-container *ngIf="repairNavGroup as repairGroup; else repairLegacySubnav">
            <a *ngIf="repairGroup.subMenus.length === 1"
              [routerLink]="getRepairSubMenuRoute(repairGroup.subMenus[0].pageUrl)"
              [queryParams]="getRepairSubMenuQueryParams(repairGroup.subMenus[0].pageUrl) || null"
              queryParamsHandling=""
              [class.active]="isRepairSubMenuActive(repairGroup.subMenus[0].pageUrl)"
              [attr.title]="isSidebarCollapsed ? repairGroup.subMenus[0].page : null"
              (click)="onRepairSubMenuClick($event, repairGroup.subMenus[0].pageUrl)">
              <img src="assets/sidebar-icons/R&M.svg" alt="" aria-hidden="true" />
              <span>{{ repairGroup.subMenus[0].page }}</span>
            </a>
            <div *ngIf="repairGroup.subMenus.length > 1" class="md-shell__nav-group"
              [class.is-open]="isSidebarGroupFlyoutOpen('repair')"
              [class.is-expanded]="!useSidebarHoverFlyout && !isSidebarCollapsed && expandedSidebarGroups.repair"
              (mouseenter)="onSidebarNavGroupMouseEnter('repair', $event)"
              (mouseleave)="onSidebarNavGroupMouseLeave('repair', $event)">
              <a [routerLink]="null" [class.active]="isRepairGroupRouteActive()"
                [attr.title]="isSidebarCollapsed ? repairGroup.menu : null"
                (click)="onSidebarGroupParentClick($event, 'repair')">
                <img src="assets/sidebar-icons/R&M.svg" alt="" aria-hidden="true" />
                <span>{{ repairGroup.menu }}</span>
              </a>
              <div class="md-shell__subnav"
                [class.is-expanded]="!useSidebarHoverFlyout && expandedSidebarGroups.repair"
                [class.md-shell__subnav--flyout]="useSidebarHoverFlyout"
                [ngStyle]="isSidebarGroupFlyoutOpen('repair') ? sidebarFlyoutNgStyle : null"
                *ngIf="shouldRenderSidebarSubnav('repair')"
                (mouseenter)="onSidebarFlyoutMouseEnter('repair')"
                (mouseleave)="onSidebarFlyoutMouseLeave('repair', $event)">
                <div class="md-shell__subnav-inner">
                  <div class="md-shell__subnav-title" *ngIf="isSidebarCollapsed">{{ repairGroup.menu }}</div>
                  <a *ngFor="let subMenu of repairGroup.subMenus"
                    [routerLink]="getRepairSubMenuRoute(subMenu.pageUrl)"
                    [queryParams]="getRepairSubMenuQueryParams(subMenu.pageUrl) || null"
                    queryParamsHandling=""
                    [class.active]="isRepairSubMenuActive(subMenu.pageUrl)"
                    (click)="onRepairSubMenuClick($event, subMenu.pageUrl)">{{ subMenu.page }}</a>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #repairLegacySubnav>
            <div class="md-shell__nav-group"
              [class.is-open]="isSidebarGroupFlyoutOpen('repair')"
              [class.is-expanded]="!useSidebarHoverFlyout && !isSidebarCollapsed && expandedSidebarGroups.repair"
              (mouseenter)="onSidebarNavGroupMouseEnter('repair', $event)"
              (mouseleave)="onSidebarNavGroupMouseLeave('repair', $event)">
              <a [routerLink]="null" [class.active]="isRepairGroupRouteActive()"
                [attr.title]="isSidebarCollapsed ? 'Repair & Maintenance' : null"
                (click)="onSidebarGroupParentClick($event, 'repair')">
                <img src="assets/sidebar-icons/R&M.svg" alt="" aria-hidden="true" />
                <span>Repair &amp; Maintenance</span>
              </a>
              <div class="md-shell__subnav"
                [class.is-expanded]="!useSidebarHoverFlyout && expandedSidebarGroups.repair"
                [class.md-shell__subnav--flyout]="useSidebarHoverFlyout"
                [ngStyle]="isSidebarGroupFlyoutOpen('repair') ? sidebarFlyoutNgStyle : null"
                *ngIf="shouldRenderSidebarSubnav('repair')"
                (mouseenter)="onSidebarFlyoutMouseEnter('repair')"
                (mouseleave)="onSidebarFlyoutMouseLeave('repair', $event)">
                <div class="md-shell__subnav-inner">
                  <div class="md-shell__subnav-title" *ngIf="isSidebarCollapsed">Repair &amp; Maintenance</div>
                  <a routerLink="/repairs-and-maintenance/list"
                    [class.active]="isNavRouteActive('/repairs-and-maintenance', { excludeSegments: ['new'] })"
                    (click)="onSidebarNavLinkClick($event, ['/repairs-and-maintenance/list'])">Repair &amp; Maintenance
                    List</a>
                  <a *ngIf="canShowApprovalProcessNav()"
                    routerLink="/approval-processes/list" [queryParams]="{ type: serviceRequestType.repairAndMainenance }"
                    [class.active]="isApprovalProcessRouteActive()"
                    (click)="onSidebarNavLinkClick($event, ['/approval-processes/list'], { type: serviceRequestType.repairAndMainenance })">Approval
                    Process</a>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="navAllowed('expense') && expenseNavGroup as expenseGroup">
          <a *ngIf="expenseGroup.subMenus.length === 1"
            [routerLink]="getExpenseSubMenuRoute(expenseGroup.subMenus[0].pageUrl)"
            [class.active]="isExpenseSubMenuActive(expenseGroup.subMenus[0].pageUrl)"
            [attr.title]="isSidebarCollapsed ? expenseGroup.subMenus[0].page : null"
            (click)="onExpenseSubMenuClick($event, expenseGroup.subMenus[0].pageUrl)">
            <img src="assets/sidebar-icons/Expense.svg" alt="" aria-hidden="true" />
            <span>{{ expenseGroup.subMenus[0].page }}</span>
          </a>
          <div *ngIf="expenseGroup.subMenus.length > 1" class="md-shell__nav-group"
            [class.is-open]="isSidebarGroupFlyoutOpen('expense')"
            [class.is-expanded]="!useSidebarHoverFlyout && !isSidebarCollapsed && expandedSidebarGroups.expense"
            (mouseenter)="onSidebarNavGroupMouseEnter('expense', $event)"
            (mouseleave)="onSidebarNavGroupMouseLeave('expense', $event)">
            <a [routerLink]="null" [class.active]="isNavRouteActive('/expenses', { includeCreate: true })"
              [attr.title]="isSidebarCollapsed ? expenseGroup.menu : null"
              (click)="onSidebarGroupParentClick($event, 'expense')">
              <img src="assets/sidebar-icons/Expense.svg" alt="" aria-hidden="true" />
              <span>{{ expenseGroup.menu }}</span>
            </a>
            <div class="md-shell__subnav"
              [class.is-expanded]="!useSidebarHoverFlyout && expandedSidebarGroups.expense"
              [class.md-shell__subnav--flyout]="useSidebarHoverFlyout"
              [ngStyle]="isSidebarGroupFlyoutOpen('expense') ? sidebarFlyoutNgStyle : null"
              *ngIf="shouldRenderSidebarSubnav('expense')"
              (mouseenter)="onSidebarFlyoutMouseEnter('expense')"
              (mouseleave)="onSidebarFlyoutMouseLeave('expense', $event)">
              <div class="md-shell__subnav-inner">
                <div class="md-shell__subnav-title" *ngIf="isSidebarCollapsed">{{ expenseGroup.menu }}</div>
                <a *ngFor="let subMenu of expenseGroup.subMenus"
                  [routerLink]="getExpenseSubMenuRoute(subMenu.pageUrl)"
                  [queryParams]="getExpenseSubMenuQueryParams(subMenu.pageUrl) || null"
                  queryParamsHandling=""
                  [class.active]="isExpenseSubMenuActive(subMenu.pageUrl)"
                  (click)="onExpenseSubMenuClick($event, subMenu.pageUrl)">{{ subMenu.page }}</a>
              </div>
            </div>
          </div>
        </ng-container>
        <a *ngIf="navAllowed('asset') && canShowAssetManagementNav()" routerLink="/asset-management/list"
          [class.active]="isNavRouteActive('/asset-management', { includeCreate: true, excludeSegments: ['new-asset'] })"
          [attr.title]="isSidebarCollapsed ? 'Asset Management' : null"
          (click)="onSidebarNavLinkClick($event, ['/asset-management/list'])">
          <img src="assets/sidebar-icons/AssetM.svg" alt="" aria-hidden="true" />
          <span>Asset Management</span>
        </a>
        <a *ngIf="navAllowed('organizations') && canShowOrganizationsNav()" routerLink="/companies/list"
          [class.active]="isNavRouteActive('/companies', { alternateBasePaths: ['/company'], includeCreate: true })"
          [attr.title]="isSidebarCollapsed ? 'Organizations' : null"
          (click)="onSidebarNavLinkClick($event, ['/companies/list'])">
          <img src="assets/sidebar-icons/organization.svg" alt="" aria-hidden="true" />
          <span>Organizations</span>
        </a>
        <a *ngIf="navAllowed('companies') && canShowCompaniesNav()" routerLink="/store-groups/list"
          [class.active]="isNavRouteActive('/store-groups', { alternateBasePaths: ['/store-group'], includeCreate: true })"
          [attr.title]="isSidebarCollapsed ? 'Companies' : null"
          (click)="onSidebarNavLinkClick($event, ['/store-groups/list'])">
          <img src="assets/sidebar-icons/Companies.svg" alt="" aria-hidden="true" />
          <span>Companies</span>
        </a>
        <a *ngIf="navAllowed('locations') && canShowLocationsNav()" routerLink="/stores/list"
          [class.active]="isNavRouteActive('/stores', { alternateBasePaths: ['/store'], includeCreate: true })"
          [attr.title]="isSidebarCollapsed ? 'Locations' : null"
          (click)="onSidebarNavLinkClick($event, ['/stores/list'])">
          <img src="assets/sidebar-icons/locations.svg" alt="" aria-hidden="true" />
          <span>Locations</span>
        </a>
        <a *ngIf="navAllowed('users') && canShowUsersNav()" routerLink="/users/list"
          [class.active]="isNavRouteActive('/users', { includeCreate: true })"
          [attr.title]="isSidebarCollapsed ? 'Users' : null" (click)="onSidebarNavLinkClick($event, ['/users/list'])">
          <img src="assets/sidebar-icons/users.svg" alt="" aria-hidden="true" />
          <span>Users</span>
        </a>
        <a *ngIf="navAllowed('roles') && canShowRolesNav()" routerLink="/roles/list"
          [class.active]="isRolesRouteActive()"
          [attr.title]="isSidebarCollapsed ? 'Roles' : null" (click)="onSidebarNavLinkClick($event, ['/roles/list'])">
          <img src="assets/sidebar-icons/roles.svg" alt="" aria-hidden="true" />
          <span>Roles</span>
        </a>
        <ng-container *ngIf="navAllowed('vendors') && canShowVendorsNav() && vendorNavGroup as vendorGroup">
          <a *ngIf="vendorGroup.subMenus.length === 1"
            [routerLink]="getVendorSubMenuRoute(vendorGroup.subMenus[0].pageUrl)"
            [queryParams]="getVendorSubMenuQueryParams(vendorGroup.subMenus[0].pageUrl) || null"
            [class.active]="isVendorSubMenuActive(vendorGroup.subMenus[0].pageUrl)"
            [attr.title]="isSidebarCollapsed ? vendorGroup.subMenus[0].page : null"
            (click)="onVendorSubMenuClick($event, vendorGroup.subMenus[0].pageUrl)">
            <img src="assets/sidebar-icons/vendors.svg" alt="" aria-hidden="true" />
            <span>{{ vendorGroup.subMenus[0].page }}</span>
          </a>
          <div *ngIf="vendorGroup.subMenus.length > 1" class="md-shell__nav-group"
            [class.is-open]="isSidebarGroupFlyoutOpen('vendor')"
            [class.is-expanded]="!useSidebarHoverFlyout && !isSidebarCollapsed && expandedSidebarGroups.vendor"
            (mouseenter)="onSidebarNavGroupMouseEnter('vendor', $event)"
            (mouseleave)="onSidebarNavGroupMouseLeave('vendor', $event)">
            <a [routerLink]="null"
              [class.active]="isNavRouteActive('/vendors', { alternateBasePaths: ['/vendor'], includeCreate: true })"
              [attr.title]="isSidebarCollapsed ? vendorGroup.menu : null"
              (click)="onSidebarGroupParentClick($event, 'vendor')">
              <img src="assets/sidebar-icons/vendors.svg" alt="" aria-hidden="true" />
              <span>{{ vendorGroup.menu }}</span>
            </a>
            <div class="md-shell__subnav"
              [class.is-expanded]="!useSidebarHoverFlyout && expandedSidebarGroups.vendor"
              [class.md-shell__subnav--flyout]="useSidebarHoverFlyout"
              [ngStyle]="isSidebarGroupFlyoutOpen('vendor') ? sidebarFlyoutNgStyle : null"
              *ngIf="shouldRenderSidebarSubnav('vendor')"
              (mouseenter)="onSidebarFlyoutMouseEnter('vendor')"
              (mouseleave)="onSidebarFlyoutMouseLeave('vendor', $event)">
              <div class="md-shell__subnav-inner">
                <div class="md-shell__subnav-title" *ngIf="isSidebarCollapsed">{{ vendorGroup.menu }}</div>
                <a *ngFor="let subMenu of vendorGroup.subMenus"
                  [routerLink]="getVendorSubMenuRoute(subMenu.pageUrl)"
                  [queryParams]="getVendorSubMenuQueryParams(subMenu.pageUrl) || null"
                  queryParamsHandling=""
                  [class.active]="isVendorSubMenuActive(subMenu.pageUrl)"
                  (click)="onVendorSubMenuClick($event, subMenu.pageUrl)">{{ subMenu.page }}</a>
              </div>
            </div>
          </div>
        </ng-container>
      </nav>

      <div class="md-shell__sidebar-footer">
        <button type="button" class="md-shell__collapse-btn" (click)="toggleSidebarCollapse()">
          <img [src]="isSidebarCollapsed ? 'assets/sidebar-icons/uncollapse.svg' : 'assets/sidebar-icons/collapse.svg'"
            alt="" aria-hidden="true" />
          <span>{{ isSidebarCollapsed ? 'Expand' : 'Collapse' }}</span>
        </button>
      </div>
    </aside>
    <button *ngIf="isMobileSidebarOpen" type="button" class="md-shell__mobile-backdrop" aria-label="Close sidebar"
      (click)="closeMobileSidebar()"></button>

    <div class="md-shell__content-wrap">
      <ng-template #quickActionsModalShell>
        <div class="quick-actions-modal">
          <div class="quick-actions-modal__header">
            <div class="quick-actions-modal__title">
              <img src="assets/sidebar-icons/cursor-box.svg" alt="" aria-hidden="true" />
              <span>Quick Action</span>
            </div>
            <button type="button" class="quick-actions-modal__close" (click)="closeQuickActionsModal()">
              <i class="ri-close-line"></i>
            </button>
          </div>

          <div class="quick-actions-modal__body">
            <div class="quick-actions-modal__search">
              <i class="ri-search-line"></i>
              <input type="text" [(ngModel)]="quickActionsSearchTerm" placeholder="Search quick actions" />
            </div>

            <div class="quick-actions-modal__list">
              <ng-container *ngIf="filteredQuickActions.length; else quickActionsShellNoResult">
                <ng-container *ngFor="let action of filteredQuickActions; let i = index">
                  <button type="button" class="quick-actions-modal__item" (click)="onQuickActionSelect(action)">
                    <span class="quick-actions-modal__item-start">
                      <span class="quick-actions-modal__item-icon" aria-hidden="true">
                        <img [src]="action.iconPath" alt="" />
                      </span>
                      <span class="quick-actions-modal__item-label">{{ action.label }}</span>
                    </span>
                    <span class="quick-actions-modal__item-shortcut">
                      <span class="quick-actions-modal__shortcut-key"
                        [class.quick-actions-modal__shortcut-key--wide]="isWideShortcutKey(key)"
                        *ngFor="let key of getShortcutKeys(action.shortcut)">
                        <span class="quick-actions-modal__shortcut-text">{{ getShortcutDisplayLabel(key) }}</span>
                      </span>
                    </span>
                  </button>
                  <div *ngIf="shouldShowQuickActionDivider(action, i, filteredQuickActions)"
                    class="quick-actions-modal__divider"></div>
                </ng-container>
              </ng-container>
              <ng-template #quickActionsShellNoResult>
                <div class="quick-actions-modal__empty">No quick action found for your search.</div>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>

      <header class="md-shell__header">
        <div class="md-shell__header-left">
          <button type="button" class="md-shell__mobile-menu-btn d-lg-none" aria-label="Open navigation menu"
            aria-controls="md-shell-sidebar-nav" [attr.aria-expanded]="isMobileSidebarOpen"
            (click)="toggleMobileSidebar()">
            <i class="ri-menu-line"></i>
          </button>
          <h1 class="md-shell__page-title">{{ currentPageTitle }}</h1>
        </div>

        <div class="md-shell__header-right">
          <!-- Assist Mode: opens the 459px AI rail beside the current page. Hidden from vendors,
               who have no AI surface, matching the Quick Action button beside it — and hidden on
               the AI page itself, where the AI *is* the page and a button offering to open it
               beside itself is nonsense. The design shows it only on product pages. -->
          <button *ngIf="!checkIfUserHasRole(RoleConstant.vendorId) && !isAiFirstRoute && aiPrefSvc.allowed" type="button"
            class="md-shell__quick-btn md-shell__ask-ai-btn"
            data-testid="ai-rail-open"
            (click)="toggleMdAiPanel()">
            <i class="ri-magic-line" aria-hidden="true"></i>
            <span>Ask MD AI</span>
          </button>

          <button *ngIf="!checkIfUserHasRole(RoleConstant.vendorId)" type="button" class="md-shell__quick-btn"
            (click)="openQuickActionsModal(quickActionsModalShell)">
            <img src="assets/sidebar-icons/cursor-box.svg" alt="" aria-hidden="true" />
            <span>Quick Action</span>
            <span class="md-shell__quick-btn-shortcut">
              <span class="md-shell__quick-btn-shortcut-key">⌘</span>
              <span class="md-shell__quick-btn-shortcut-key">K</span>
            </span>
          </button>

          <div class="header-item" *ngIf="checkIfUserHasRole(RoleConstant.globalAdminId)">
            <ng-select [items]="companies$ | async" bindLabel="name" bindValue="id" [(ngModel)]="selectedCompany"
              [loading]="(companies$ | async) === null" loadingText="Loading organizations..."
              dropdownPosition="bottom" (change)="onCompanyChange($event)" [clearable]="false" [searchable]="false"
              placeholder="Select Organization">
            </ng-select>
          </div>

          <!-- System Admin portal has no notifications page (QA B80): no bell outside an organization. -->
          <div *ngIf="!(isSystemAdmin && !isImpersonating)" #notificationDropdown class="dropdown header-item" id="notificationDropdown">
            <button #dropdownToggle type="button" (click)="onNotificationIconClick($event)"
              class="btn btn-icon btn-topbar" id="page-header-notifications-dropdown" data-bs-toggle="dropdown"
              data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
              <img class="md-shell__bell-icon" src="assets/icons/bellicons.svg" alt="" aria-hidden="true" />
              <ng-container *ngIf="counts$ | async as unreadCount"><span *ngIf="unreadCount > 0" class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">{{ formatNotificationCount(unreadCount) }}<span class="visually-hidden">unread messages</span></span></ng-container>
            </button>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 notifications-dropdown-menu"
              aria-labelledby="page-header-notifications-dropdown">
              <div class="dropdown-head rounded-top">
                <div class="p-3 border-bottom notifications-dropdown-head">
                  <div class="d-flex flex-nowrap align-items-end justify-content-between gap-2">
                    <ul class="nav nav-tabs dropdown-notification-tabs mb-0 border-0 flex-grow-1 min-w-0"
                      role="tablist">
                      <li class="nav-item flex-shrink-0" role="presentation">
                        <button type="button" class="nav-link bell-tab-button bg-transparent p-0 me-3 text-nowrap"
                          [class.active]="activeNotificationTab === 'notifications'"
                          (click)="activeNotificationTab = 'notifications'">
                          <span class="align-middle">Notifications</span>
                          <span *ngIf="notificationsTabUnreadDot$ | async" class="ms-1 align-middle bell-tab-unread-dot"
                            aria-hidden="true"></span>
                        </button>
                      </li>
                      <li class="nav-item flex-shrink-0" role="presentation">
                        <button type="button" class="nav-link bell-tab-button bg-transparent p-0 text-nowrap"
                          [class.active]="activeNotificationTab === 'announcements'"
                          (click)="activeNotificationTab = 'announcements'">
                          <span class="align-middle">Announcements</span>
                          <span *ngIf="announcementsTabUnreadDot$ | async" class="ms-1 align-middle bell-tab-unread-dot"
                            aria-hidden="true"></span>
                        </button>
                      </li>
                    </ul>
                    <button type="button"
                      class="notifications-dropdown-mark-all d-inline-flex align-items-center flex-shrink-0 text-nowrap border-0"
                      (click)="activeNotificationTab === 'announcements' ? markAllAnnouncementsAsRead() : markAllAsRead()">
                      <span class="notifications-mark-all-read-link">Mark all as read</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="tab-content position-relative" id="notificationItemsTabContent">
                <div class="tab-pane fade" [class.show]="activeNotificationTab === 'notifications'"
                  [class.active]="activeNotificationTab === 'notifications'" role="tabpanel">
                  <div data-simplebar style="max-height: 300px; overflow-y: auto;" class="pe-2">
                    <ng-container
                      *ngIf="activeNotificationTab === 'notifications' && (notificationlist$ | async) as data">
                      <ng-container *ngIf="data && data.items.length; else noData">
                        <div class="text-reset notification-item d-block dropdown-item position-relative"
                          [ngClass]="{ 'read-noti-bg-light': notification.state === 'UnRead' }"
                          *ngFor="let notification of data.items; trackBy: trackByFn">
                          <div class="d-flex">
                            <div class="flex-grow-1">
                              <a (click)="onNotificationClick(notification)"
                                [attr.data-module]="notification.module | kebabCase"
                                class="stretched-link text-decoration-none cursor-pointer">
                                <div class="d-flex align-items-center justify-content-between mb-1">
                                  <div class="d-flex align-items-center gap-2">
                                    <img *ngIf="notification.state === 'UnRead'"
                                      src="assets/images/svg/notification-dot.svg" alt="icon" />
                                    <h3 class="mb-0 text-truncate"
                                      style="font-size: 15px; color: #0F172A; max-width: 150px;">
                                      {{ notification.title }}
                                    </h3>
                                  </div>
                                  <p class="mb-0 fs-11 fw-medium text-muted">
                                    <span>{{ notification.createdAt | relativeTime }}</span>
                                  </p>
                                </div>
                                <h6 class="mt-0 mb-2 lh-base text-muted fs-12">{{ notification.body }}</h6>
                              </a>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-template #noData>
                        <ng-container *ngIf="!(isLoading$ | async)">
                          <div class="card-body p-4 m-4">
                            <div class="text-center">
                              <h5 class="mt-2">No notifications</h5>
                            </div>
                          </div>
                        </ng-container>
                      </ng-template>
                    </ng-container>
                  </div>
                  <div (click)="onViewAllNotifications()" class="text-center border-top p-2 all-notification"
                    style="background-color: #fff; position: sticky; bottom: 0; z-index: 10; cursor: pointer;">
                    View all notifications
                  </div>
                </div>
                <div class="tab-pane fade" [class.show]="activeNotificationTab === 'announcements'"
                  [class.active]="activeNotificationTab === 'announcements'" role="tabpanel">
                  <div class="px-3 pt-2 pb-1 text-muted small fw-medium">Today</div>
                  <div data-simplebar style="max-height: 300px; overflow-y: auto; overflow-x: hidden;" class="pe-2">
                    <ng-container
                      *ngIf="activeNotificationTab === 'announcements' && (announcementlist$ | async) as data">
                      <ng-container *ngIf="data && data.items.length; else shellNoDataAnnouncements">
                        <div class="text-reset notification-item d-block dropdown-item position-relative m-1"
                          style="border-radius: 5px;"
                          [ngClass]="{ 'read-noti-bg-light': announcement.status === 'UnRead' }"
                          *ngFor="let announcement of data.items; trackBy: trackByAnnouncementFn">
                          <div class="d-flex">

                            <div class="flex-grow-1">
                              <a (click)="onAnnouncementClick(announcement)"
                                class="stretched-link text-decoration-none cursor-pointer">
                                <div class="d-flex align-items-center justify-content-between mb-1 flex-wrap gap-1">
                                  <span [ngClass]="getAnnouncementTypeClass(announcement.type)"
                                    class="announcement-type-pill-dropdown">
                                    <span class="announcement-type-dot"></span>
                                    {{ getAnnouncementTypeLabel(announcement.type) }}
                                  </span>
                                  <p class="mb-0 fs-11 fw-medium text-muted flex-shrink-0">
                                    <span>{{ (announcement.createdAt || announcement.scheduledDate) | relativeTime
                                      }}</span>
                                  </p>
                                </div>
                                <div class="d-flex align-items-center gap-2 mb-1">
                                  <img *ngIf="announcement.status === 'UnRead'"
                                    src="assets/images/svg/notification-dot.svg" alt="icon" />
                                  <h3 class="mb-0 text-truncate"
                                    style="font-size: 15px; color: #0F172A; font-weight: 600;">
                                    {{ announcement.title || '—' }}
                                  </h3>
                                </div>
                                <h6 class="mt-0 mb-2 lh-base text-muted fs-12">
                                  <span class="announcement-description-truncate">
                                    {{ getAnnouncementDescriptionPreview(announcement.description) }}
                                  </span>
                                </h6>
                              </a>
                            </div>

                          </div>
                        </div>

                      </ng-container>

                      <ng-template #shellNoDataAnnouncements>
                        <ng-container *ngIf="!(announcementsLoading$ | async)">
                          <div class="card-body p-4 m-4">
                            <div class="noresult">
                              <div class="text-center">
                                <h5 class="mt-2">Sorry! No Result Found</h5>
                                <p class="text-muted mb-0">
                                  We did not find any announcement for your search.
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-template>
                    </ng-container>
                  </div>
                  <div (click)="onViewAllAnnouncements()" class="text-center border-top p-2 all-notification"
                    style="background-color: #fff; position: sticky; bottom: 0; z-index: 10; color: #6964E1; font-weight: 500; cursor: pointer;">
                    View all Announcements
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="dropdown header-item topbar-user" dropdown container="body" placement="bottom end"
            [isAnimated]="false" [isOpen]="isProfileMenuOpen" (isOpenChange)="onProfileMenuOpenChange($event)"
            [autoClose]="true">
            <button #profileDropdownToggle type="button" class="btn md-shell__user-btn" dropdownToggle
              [attr.aria-label]="'Account menu for ' + getUserName(user)">
              <span class="d-flex align-items-center">
                <ng-container *ngIf="!user?.profilePictureWebUrl">
                  <div class="avatar-xs flex-shrink-0">
                    <div class="avatar-title rounded-circle">{{user | userPrefix}}</div>
                  </div>
                </ng-container>
                <ng-container *ngIf="user?.profilePictureWebUrl">
                  <img class="rounded-circle header-profile-user" [src]="user?.profilePictureWebUrl" alt="" />
                </ng-container>
                <span class="text-start d-none d-xl-flex flex-column">
                  <span class="user-name-text">{{ getFirstThreeWords(getUserName(user)) }}</span>
                  <span class="user-name-sub-text">{{ getRoleName(activeRoleId) }}</span>
                </span>
                <img class="md-shell__user-chevron d-none d-xl-inline-block" src="assets/icons/chevron-down.svg" alt=""
                  aria-hidden="true" />
              </span>
            </button>

            <div class="dropdown-menu dropdown-menu-end md-shell-profile-menu" *dropdownMenu>
              <div class="md-shell-profile-menu__surface" [class.is-closing]="isProfileMenuClosing">
                <div class="dropdown-header md-shell-profile-menu__header">
                  <div class="md-shell-profile-menu__identity">
                    <ng-container *ngIf="user?.profilePictureWebUrl; else profileFallbackAvatar">
                      <img class="md-shell-profile-menu__avatar" [src]="user?.profilePictureWebUrl" alt="Profile" />
                    </ng-container>
                    <ng-template #profileFallbackAvatar>
                      <div class="md-shell-profile-menu__avatar-fallback">{{ user | userPrefix }}</div>
                    </ng-template>
                    <div class="md-shell-profile-menu__identity-text">
                      <div class="md-shell-profile-menu__name">{{ getFirstThreeWords(getUserName(user)) }}</div>
                      <div class="md-shell-profile-menu__role">{{ getRoleName(activeRoleId) }}</div>
                    </div>
                  </div>
                </div>

                <div class="md-shell-profile-menu__section md-shell-profile-menu__section--links">
                  <a class="dropdown-item md-shell-profile-menu__item" [routerLink]="['/profile']">
                    <img src="assets/sidebar-icons/user-icon.svg" alt="" aria-hidden="true" />
                    <span>View profile</span>
                  </a>
                  <a class="dropdown-item md-shell-profile-menu__item"
                    *ngIf="canOpenOrganizationSettings"
                    [routerLink]="[organizationSettingsUrl]">
                    <img src="assets/sidebar-icons/settings-icon.svg" alt="" aria-hidden="true" />
                    <span>Organization Settings</span>
                  </a>
                  <a class="dropdown-item md-shell-profile-menu__item" (click)="openChangePasswordModal()">
                    <img src="assets/sidebar-icons/pwd-icon.svg" alt="" aria-hidden="true" />
                    <span>Change Password</span>
                  </a>
                </div>

                <div class="dropdown-divider"></div>

                <!-- AC 9.1, 9.2: in the System Admin portal only View profile, Change Password and Log out.
                     Inside an organization the System Admin gets the usual menu. -->
                <ng-container *ngIf="!isSystemAdmin || isImpersonating">
                <div class="md-shell-profile-menu__section">
                  <div class="md-shell-profile-menu__title">Switch Role</div>
                  <div class="md-shell-profile-menu__roles">
                    <button *ngFor="let role of uniqueRoles | userRolesToList" type="button"
                      class="md-shell-profile-menu__role-chip" [class.is-active]="role.roleId === activeRoleId"
                      (click)="onSwitchRole(role)">
                      <span class="md-shell-profile-menu__role-radio" aria-hidden="true"></span>
                      <span>{{ role?.roleName }}</span>
                    </button>
                  </div>
                </div>

                <div class="dropdown-divider"></div>

                <a class="dropdown-item md-shell-profile-menu__item"
                  *ngIf="canShowAnnouncementsMenu()"
                  [routerLink]="['/announcements/list']">
                  <img src="assets/sidebar-icons/An-icon.svg" alt="" aria-hidden="true" />
                  <span>Announcement</span>
                </a>
                <a class="dropdown-item md-shell-profile-menu__item"
                  *ngIf="canOpenIntegrationData"
                  [routerLink]="['/integration-data']">
                  <img src="assets/sidebar-icons/integration-icon.svg" alt="" aria-hidden="true" />
                  <span>Integration data &amp; import jobs</span>
                </a>
                <a class="dropdown-item md-shell-profile-menu__item" [routerLink]="['/notifications/preferences']">
                  <img src="assets/images/svg/notifications-per-bell.svg" alt="" aria-hidden="true" />
                  <span>Notifications Preferences</span>
                </a>
                <a class="dropdown-item md-shell-profile-menu__item" [routerLink]="['/ai-preferences']">
                  <img src="assets/sidebar-icons/AI.svg" alt="" aria-hidden="true" />
                  <span>AI Preferences</span>
                </a>
                <a class="dropdown-item md-shell-profile-menu__item" [routerLink]="['/support/new']">
                  <img src="assets/sidebar-icons/help-icon.svg" alt="" aria-hidden="true" />
                  <span>Help &amp; Support</span>
                </a>
                <div class="dropdown-divider"></div>
                </ng-container>

                <a class="dropdown-item md-shell-profile-menu__logout" (click)="logout()">
                  <img src="assets/sidebar-icons/logout-icon.svg" alt="" aria-hidden="true" />
                  <span>Log out</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main class="md-shell__content" [ngClass]="{ 'mdai-panel-open': mdAiPanelOpen }">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>

<app-md-ai-panel *ngIf="aiPrefSvc.allowed"></app-md-ai-panel>
</ng-template>

<input
  #quickActionBulkApFileInput
  type="file"
  class="d-none"
  [attr.accept]="quickActionBulkApAccept"
  multiple
  (change)="onQuickActionBulkApFilesSelected($event)"
/>
<app-spinner
  *ngIf="isBulkApUploading$ | async"
  message="Creating draft requests..."></app-spinner>
